<script setup>
import { computed } from "vue"
import { useFilteredFeedStore } from "../stores/FilteredFeed.js"
const store = useFilteredFeedStore()

const pageMessage = computed(() => {
	return `Page ${ store.page } of ${ store.maxNumPages }`
})

</script>

<template>
	<div v-if="store.maxNumPages !== 1" class="flex flex-col md:flex-row gap-4 md:items-center mt-24" role="navigation" aria-label="Pagination">
		<div class="flex gap-4 justify-center">
			<button aria-label="Previous page" :disabled="store.page === 1" @click="store.navigatePrev()" :class="{ '!bg-black text-grey pointer-events-none' : store.page === 1 }" href="#" class="circle bg-grey hover:bg-blue hover:text-white transition">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
					<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
				</svg>
			</button>
			<button aria-label="Next page" :disabled="store.page === store.maxNumPages" @click="store.navigateNext()" :class="{ '!bg-black text-grey pointer-events-none' : store.page === store.maxNumPages }" href="#" class="circle bg-grey hover:bg-blue hover:text-white transition">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
					<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
				</svg>
			</button>
		</div>
		<div class="hidden md:flex capsule flex-grow bg-grey">{{ pageMessage }}</div>
	</div>
</template>
